const PIXEL_ID = '2444605186007883'

export function initMetaPixel(): void {
  if (typeof window === 'undefined') return
  const w = window as any
  if (w.fbq) return

  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  w.fbq = n
  if (!w._fbq) w._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // noscript fallback
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
  noscript.appendChild(img)
  document.body.appendChild(noscript)

  w.fbq('init', PIXEL_ID)
  w.fbq('track', 'PageView')
}

export function trackEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  const w = window as any
  if (typeof w.fbq === 'function') {
    w.fbq('trackCustom', eventName, params)
  }
}

export function trackStandardEvent(
  eventName: string,
  params?: Record<string, any>,
): void {
  const w = window as any
  if (typeof w.fbq === 'function') {
    w.fbq('track', eventName, params)
  }
}

export function trackButtonClick(buttonText: string): void {
  const sanitized = buttonText
    .replace(/[^\w\sáéíóúñü]/gi, '')
    .trim()
    .replace(/\s+/g, '_')
  trackEvent(`Click_${sanitized}`, { button_text: buttonText })
}
